import { withTranslation, TFunction } from "react-i18next";
import { JobSummary } from "./JobSummary";

interface IjobDescription {
  t: TFunction<"translation", undefined>;
  jobDescription?: {
    description?: string;
    atsJobId: string;
    jobSummary: Record<string, string[]> | null;
  };
}

const JobDescription = ({ jobDescription, t }: IjobDescription) => {
  const dynamicHTML = (description) => {
    /* eslint-disable */
    return <div dangerouslySetInnerHTML={{ __html: description }} />;
  };

  const job = jobDescription;
  let description;
  if (job?.description) {
    description = dynamicHTML(job?.description.split("Posted Date")[0]);
  } else {
    description = t("jobs.jobDescription.noJobsDescription");
  }

  const jobSummary = job?.jobSummary;
  const hasJobSummary =
    jobSummary && typeof jobSummary === "object" && Object.keys(jobSummary).length > 0;

  return (
    <div>
      <div className="jobCardMain">
        <div className="JobDescriptionRow">
          <div className="JobDescriptionTab">{description}</div>
          {hasJobSummary && (
            <div>
              <JobSummary
                jobSummary={job?.jobSummary ? job?.jobSummary : null}
                aiSummaryTitle={t("jobs.jobDescription.aiSummaryTitle")}
                aiSummaryDescription={t("jobs.jobDescription.aiSummaryDescription")}
              />
            </div>
          )}
        </div>
        <span className="JobDescriptionJobID">
          {job?.atsJobId ? `${t("jobDetails.jobId")} ${job?.atsJobId}` : ""}
        </span>
      </div>
    </div>
  );
};

JobDescription.defaultProps = {
  jobDescription: {
    description: "",
    atsJobId: "",
  },
};

export default withTranslation()(JobDescription);
